// extracted by mini-css-extract-plugin
module.exports = {"PageTitle":"PageTitle_PageTitle__ytvPc","BackButton":"PageTitle_BackButton__1m3Pj"};